const api = {}

const BASE_URL = "https://api.cleanbox.co.il" //prod
//const BASE_URL = "https://api-test.cleanbox.co.il" //test
//const BASE_URL = "https://localhost:5001" //local

//LOGIN
api.deleteAccount = `${BASE_URL}/api/User/delete_account`
api.signInBody = (mobilePhone, pwd) => {
  return {
    mobilePhone: mobilePhone,
    password: pwd,
  }
}

export default api
